import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BaseGrid from '../Common/BaseGrid';

function InventorySelector(props) {
  const { onSelect } = props;

  const selectItem = (item) => {
    onSelect(item);
  };

  return (
    <BaseGrid
      url="/api/inventory"
      hasSearch
      config={{
        columns: {
          stock_id: { label: 'Stock ID', sort: true },
          manufacturer: { label: 'Manufacturer', sort: true },
          part_number: { label: 'Part Number', sort: true },
          ship_desc: { label: 'Desc', sort: false },
          qty: { label: 'Qty', sort: true },
          actions: {
            label: 'Actions',
            actions: [
              {
                key: 'select_item',
                icon: 'mdi mdi-check-bold',
                class: 'btn btn-sm btn-soft-info text-dark',
                alt: 'Select',
                click: selectItem,
              },
            ],
          },
        },
        pagination: {
          sort: 'stock_id',
          direction: 'asc',
          perPage: 5,
        },
      }}
    />
  );
}

InventorySelector.defaultProps = {
  onSelect: () => {},
};

InventorySelector.propTypes = {
  onSelect: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(InventorySelector));
